<script>
export default {
  name: 'IFrame',
}
</script>

<script setup>
import { NodeViewWrapper, nodeViewProps } from "@tiptap/vue-3"
import useNodeProps from "@/Composables/useNodeProps"
import EditableNode from "./../../Components/EditableNodeWrapper.vue"
import EditIFrame from "../../Modals/EditIFrame.vue";
import { InformationCircleIcon } from "@heroicons/vue/24/outline"

const props = defineProps({
  ...nodeViewProps,
})

let { src, height, width, justify } = useNodeProps(props)
</script>

<template>
  <node-view-wrapper>
    <EditableNode v-bind="props">
      <template #tools>
        <EditIFrame
          v-model:src="src"
          v-model:justify="justify"
          v-model:width="width"
          v-model:height="height"
        />
      </template>
      <template #content>
        <div v-if="src !== ''" :class="['flex justify-' + justify]">
          <iframe
            :src="src"
            :width="width"
            :height="height"
          >
            {{ __('IFrame source Loading...') }}
          </iframe>
        </div>
        <div v-else class="my-4 text-center space-y-1">
          <InformationCircleIcon class="mx-auto w-12 h-12 text-gray-300"/>
          <h3 class="text-sm font-semibold text-gray-600">
            {{ __('No source provided') }}
          </h3>
        </div>
      </template>
    </EditableNode>
  </node-view-wrapper>
</template>
